const ITEMS = ["ESTRATÉGIA", "TECNOLOGIA", "PRESENÇA DIGITAL", "RESULTADO"];

const Diamond = () => <span className="inline-block w-1.5 h-1.5 rotate-45 bg-gold/70 mx-8 shrink-0" />;

const Marquee = () => {
    const row = (hidden) => (
        <div className="flex items-center shrink-0" aria-hidden={hidden || undefined}>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="font-display text-lg sm:text-2xl font-semibold tracking-[0.18em] text-ink3 whitespace-nowrap">
                        {item}
                    </span>
                    <Diamond />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="brand-marquee"
            className="relative border-y border-line/70 py-6 overflow-hidden bg-[#0a0a0e]"
        >
            <div className="flex w-max animate-marquee">
                {row(false)}
                {row(true)}
            </div>
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-bg to-transparent" />
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-bg to-transparent" />
        </div>
    );
};

export default Marquee;
